import apiClient from "../../utils/apiClient";

const API_URL = "/services";

export async function getAllService() {
  try {
    const response = await apiClient.get(`${API_URL}/`);
    console.log('Service Data:', response.data);
    return response.data;  
  } catch (error) {
    console.error('Error fetching service names:', error);
    throw error;
  }
}

// Get all unique service names
export async function getServiceNames() {
  try {
    const response = await apiClient.get(`${API_URL}/names`);
    return response.data;
  } catch (error) {
    console.error('Error fetching service names:', error);
    throw error;
  }
}

// Get types for a specific service name
export async function getServiceTypes(serviceName) {
  try {
    const response = await apiClient.get(`${API_URL}/${serviceName}/types`);
    return response.data;
  } catch (error) {
    console.error('Error fetching service types:', error);
    throw error;
  }
}

// Get categories for a specific service name and type
export async function getServiceCategories(serviceName, serviceType) {
  try {
    const response = await apiClient.get(`${API_URL}/${serviceName}/${serviceType}/categories`);
    return response.data;
  } catch (error) {
    console.error('Error fetching service categories:', error);
    throw error;
  }
}